// ตำแหน่งทุกอย่างบนกระดาษคำตอบ หน่วยเป็นมิลลิเมตรบน A4 (210 x 297)
//
// ไฟล์นี้เป็นสัญญาระหว่าง "ตัวพิมพ์" กับ "ตัวอ่าน" (ขั้นสแกน) — ทั้งสองต้องเรียกฟังก์ชันเดียวกันนี้
// ห้ามเขียนตัวเลขตำแหน่งซ้ำที่อื่น และห้ามแก้ตัวเลขเมื่อมีกระดาษที่พิมพ์ไปแล้วยังรอสแกน
// ถ้าต้องเปลี่ยนแบบกระดาษ ให้เพิ่ม LAYOUT_VERSION แล้วให้ตัวอ่านเลือกตามรุ่นที่พิมพ์บนแผ่น
//
// ตัวอ่านจัดภาพให้ตรงจากศูนย์กลางสี่เหลี่ยมทึบสี่มุม (markers) แล้วอ่านทุกช่องด้วยพิกัดจากที่นี่
// ตำแหน่งข้อจึงขึ้นกับ "ลำดับของข้อปรนัย" เท่านั้น (ข้ออัตนัยไม่มีช่องฝน) — โครงข้อสอบถูกล็อก
// ทันทีที่มีคำตอบด้วยเหตุผลนี้ (ดู examModel.updateExam)
import { CODE_BITS } from './sheetCode'

export const LAYOUT_VERSION = 1

export const PAGE = { width: 210, height: 297 }

const MARKER = 7
export const MARKERS = [
  { corner: 'tl', x: 10, y: 10, size: MARKER },
  { corner: 'tr', x: PAGE.width - 10 - MARKER, y: 10, size: MARKER },
  { corner: 'bl', x: 10, y: PAGE.height - 10 - MARKER, size: MARKER },
  { corner: 'br', x: PAGE.width - 10 - MARKER, y: PAGE.height - 10 - MARKER, size: MARKER },
]

// แถบรหัสแผ่น 2 แถว แถวละ 26 ช่อง
const CODE_PER_ROW = CODE_BITS / 2
const CODE_CELL = 4
const CODE_PITCH = 5.5
const CODE_X0 = (PAGE.width - (CODE_PER_ROW - 1) * CODE_PITCH - CODE_CELL) / 2
const CODE_Y0 = 52

// ตารางช่องฝน 4 คอลัมน์ x 25 ข้อ
export const COLUMNS = 4
export const ROWS_PER_COLUMN = 25
export const MAX_BUBBLE_QUESTIONS = COLUMNS * ROWS_PER_COLUMN
const GRID_X0 = 16
const COLUMN_WIDTH = 44.5
const GRID_Y0 = 78          // ศูนย์กลางแถวแรก
const ROW_PITCH = 8
const BUBBLE_R = 2.4
const BUBBLE_X0 = 12.5      // ศูนย์กลางช่องแรกนับจากขอบซ้ายของคอลัมน์
const BUBBLE_PITCH = 6.5

const CHOICE_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ']
const TF_OPTIONS = [{ value: 'T', label: 'ถ' }, { value: 'F', label: 'ผ' }]

export const codeCells = () => Array.from({ length: CODE_BITS }, (_, i) => ({
  index: i,
  x: CODE_X0 + (i % CODE_PER_ROW) * CODE_PITCH,
  y: CODE_Y0 + Math.floor(i / CODE_PER_ROW) * CODE_PITCH,
  size: CODE_CELL,
}))

// questions = [{ eq_no, eq_type }] เรียงตาม eq_no — คืนตำแหน่งเลขข้อและช่องฝนของข้อปรนัย
export const bubbleLayout = (questions, choices) => {
  const objective = questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse')
  if (objective.length > MAX_BUBBLE_QUESTIONS) {
    throw new Error(`กระดาษหนึ่งแผ่นรับข้อปรนัยได้ไม่เกิน ${MAX_BUBBLE_QUESTIONS} ข้อ`)
  }
  return objective.map((q, i) => {
    const colX = GRID_X0 + Math.floor(i / ROWS_PER_COLUMN) * COLUMN_WIDTH
    const cy = GRID_Y0 + (i % ROWS_PER_COLUMN) * ROW_PITCH
    const options = q.eq_type === 'truefalse'
      ? TF_OPTIONS
      : CHOICE_LABELS.slice(0, choices).map((label, k) => ({ value: String(k + 1), label }))
    return {
      eq_no: q.eq_no,
      eq_type: q.eq_type,
      numberX: colX + 8,
      cy,
      bubbles: options.map((o, k) => ({
        value: o.value,
        label: o.label,
        cx: colX + BUBBLE_X0 + k * BUBBLE_PITCH,
        cy,
        r: BUBBLE_R,
      })),
    }
  })
}
